<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">Consegna {{delivery?.id}}</h2>
    <br class="clear"><br class="clear">
    <span class="left">
        <button class="btn btn-white has-margin-right" (click)="print($event)">
          <i class="ml-10 fas fa-file"></i>&nbsp;Stampa
        </button>
    </span>
    <span class="left">
    <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="directions($event)">
      <i class="ml-10 fas fa-directions"></i>&nbsp;Maps
    </button>
    </span>
    <span class="left">
    <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="showLink($event)">
      <i class="ml-10 fas fa-link"></i>&nbsp;Share
    </button>
    <button class="btn btn-white has-margin-right" style="margin-left: 5px;" *ngIf="delivery?.status != deliveryStatus?.delivered" (click)="showLink($event, 'delivered')">
      <i class="ml-10 fas fa-link"></i>&nbsp;Delivered Link
    </button>
    <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="expertModal(delivery)" *ngIf="(groupWhitelisted(['admin', 'operation']) || (groups.includes('expert') && user?.expert?.isTeamLeader))">
      <i class="ml-10 fas fa-user-plus"></i>&nbsp;Assegna
    </button>
  </span>
  <span class="left">
      <button class="btn btn-white has-margin-right" (click)="accepting(delivery.id)"
      *ngIf="groupWhitelisted('partner') && delivery?.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned) && delivery?.createdFrom === null">
        Accetta<i class="ml-10 fas fa fa-check"></i>
      </button>
    </span>
    <span class="left">
    <button class="btn btn-white has-margin-right" (click)="refusing(delivery.id)"
    *ngIf="groupWhitelisted('partner') && delivery?.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned) && delivery?.createdFrom === null">
      Rifiuta  <i class="ml-10 fas fa-times-circle"></i>
    </button>
    </span>
    <br class="clear">
  </div>
</section>


<section id="schedaConsegna" class="content-padding" *ngIf="delivery">
  <div class="narrow-wrapper">
    <button class="btn center has-margin-top" (click)="delivering(delivery.id)" *ngIf="selected == 'active' && groupWhitelisted(['expert']) && delivery.status == deliveryStatus.assigned">
      In consegna<i class="ml-10 fas fa-truck"></i>
    </button>

    <div class="delivery-colle-data-box" style="margin-top: 15px;">
      <fieldset>
        <legend>DATI DI CONSEGNA E RITIRO:</legend>

        <div class="col-50 grid-element field">
          <h3>Stato</h3>
          <p id="outpuStato" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">{{deliveryStatusAux.ln('it', delivery.status)}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Servizio Logo</h3>
          <p> {{ serviceDetails?.image ? "" : "No" }}
            <img [src]="serviceDetails?.image" height="70px" width="100px" *ngIf="serviceDetails?.image" alt="Servizio image" class="logo">
          </p>
        </div>
    
        <br class="clear">
        <div class="col-50 grid-element field">
          <h3>Data consegna</h3>
          <p>{{(delivery.actualDate || delivery.deliveryDate) | date:"dd/MM/yyyy" || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field" *ngIf="serviceDetails?.pricingModel?.toLowerCase() != 'hourlyrate'">
          <h3>Fascia oraria Consegna</h3>
          <p>
            {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "N/A"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "N/A"}}
          </p>
        </div>
        <div class="col-50 grid-element field" *ngIf="serviceDetails?.pricingModel?.toLowerCase() === 'hourlyrate'">
          <h3>Start and End Time</h3>
          <p>
            {{(delivery.startTime) ? (delivery.startTime | time: 'HH:mm') : "N/A"}} - {{(delivery.endTime) ? (delivery.endTime | time: 'HH:mm') : "N/A"}}
          </p>
        </div>
        <div class="col-50 grid-element field" *ngIf="serviceDetails === null">
          <h3>Start and End Time</h3>
          <p>
            {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "N/A"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "N/A"}}
          </p>
        </div>

        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'expert', 'partner', 'operation'])">
          <h3>Ora Ritiro</h3>
          <p id="outputExpert">{{ delivery?.pickUpTime || "N/A" }}</p>
        </div>

        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <h3>Consegna flessibile</h3>
          <p>{{delivery.requestExpert ? "Sì" : "No"}}</p>
        </div>

        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <h3>Valet</h3>
          <p id="outputExpert">
            {{delivery.expert ? delivery.expert.user.surname + " " + delivery.expert.user.name : "N/A"}}
          </p>
        </div>

        <div class="col-50 grid-element field" *ngIf="groupWhitelisted('expert')">
          <h3>Indirizzo di ritiro</h3>
          <p id="outputExpert">{{delivery?.pickUpAddress || "N/A"}}</p>
        </div>
    
        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['partner'])">
          <h3>Mezzo</h3>
          <p *ngIf="!delivery.expert">
            <span style="display: block;">
              {{ "N/A" }}
            </span>
          </p>
          <p id="outputProdotto" *ngFor="let vehicle of delivery.expert?.vehicles">
            <span style="display: block;">
              {{ vehicle.name }}
            </span>
          </p>
        </div>
    
        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['partner'])">
          <h3>Telefono esperto</h3>
          <p>{{delivery.expert?.phone || "N/A"}}</p>
        </div>
      </fieldset>
    </div>

        <div class="service-details" style="margin-top: 15px;">
          <fieldset>
            <legend>SCELTA DEL SERVIZIO :</legend>
            <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'expert', 'operation'])">
              <h3>Partner</h3>
              <p id="outputPartner">{{delivery.partner?.businessName || "N/A"}}</p>
            </div>
        
            <div class="col-50 grid-element field">
              <h3 style="margin-bottom: 16px;">Nome Servizio</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">
                    {{ 
                      groupWhitelisted(['partner']) ?
                      serviceDetails?.serviceName?.toUpperCase() :
                      showServiceDetails(delivery?.service)?.service?.serviceName?.toUpperCase() || "N/A" 
                    }} 
                  </div>
                </div>
            </div>
        
            <div class="col-50 grid-element field">
              <h3 style="margin-bottom: 16px;">Tipo Servizio</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">
                    {{ delivery?.serviceType &&
                      (delivery.serviceType.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
                      (delivery.serviceType.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
                      (delivery.serviceType.toLowerCase() === "sales" ? "Servizi Vendita" : ""))) 
                    }} 
                  </div>
                </div>
            </div>
        
            <div class="col-50 grid-element field" *ngIf="(serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['admin', 'expert']))">
              <h3 style="margin-bottom: 16px;">Prezzo</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">{{ delivery?.productValue || "0" }}€ </div>
                </div>
            </div>

            <div class="col-50 grid-element field" *ngIf="(serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['partner']))">
              <h3 style="margin-bottom: 16px;">Prezzo</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">{{ delivery?.productValue || "0" }}€ </div>
                </div>
            </div>

            <div class="col-50 grid-element field" 
              *ngIf="(
                (serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['partner']))
                  || ((serviceDetails?.pricingModel?.toLowerCase() === 'hourlyrate' || serviceDetails?.pricingModel?.toLowerCase() === 'fixedprice') && groupWhitelisted(['partner']) && loggedInPartner?.billingAccess)
              )"
              >
              <h3 style="margin-bottom: 16px;">Valore Fee</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">{{ delivery?.price || "0" }}€ </div>
                </div>
            </div>
        
            <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin']) || (serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['partner', 'expert']))">
              <h3 style="margin-bottom: 16px;">Plus / Minus al Prezzo</h3>
                <div style="display: flex; justify-content: space-between; padding-right:16px;">
                  <div style="width: 250px;">{{ delivery?.additionalPrice || "0" }}€ </div>
                </div>
            </div>
          </fieldset>
        </div>

    <div class="recipient-sender-info-box" style="margin-top: 15px;">
      <fieldset>
        <legend>INFORMAZIONI DESTINATARIO E MITTENTE:</legend>

        <div class="col-50 grid-element field">
          <h3>Cognome destinatario</h3>
          <p>{{delivery.surname || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Nome destinatario</h3>
          <p>{{delivery.name || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Sms Telefonici</h3>
          <p>{{delivery?.smsPhoneNo || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Indirizzo</h3>
          <p>{{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Citofono</h3>
          <p>{{delivery.intercom || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Telefono destinatario</h3>
          <p>{{delivery.receiverPhone || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Email destinatario</h3>
          <p>{{delivery.email || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Cognome mittente</h3>
          <p *ngIf="delivery.customer">{{delivery.customer.user.surname || "N/A"}}</p>
          <p *ngIf="!delivery.customer">{{delivery.senderSurname || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Nome mittente</h3>
          <p *ngIf="delivery.customer">{{delivery.customer.user.name || "N/A"}}</p>
          <p *ngIf="!delivery.customer">{{delivery.senderName || "N/A"}}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Telefono mittente</h3>
          <p *ngIf="delivery.customer">{{delivery.customer.phone || "N/A"}}</p>
          <p *ngIf="!delivery.customer">{{delivery.senderPhone || "N/A"}}</p>
        </div>

      </fieldset>
    </div>

    <div class="order-management-box" style="margin-top: 15px;">
      <fieldset>
        <legend>GESTIONE DELL’ORDINE:</legend>
        
        <div class="col-50 grid-element field">
          <h3>Pagamento alla consegna</h3>
          <p>{{ delivery.payAtDelivery ? "Sì" : "No" }}</p>
        </div>

        <div class="col-50 grid-element field" *ngIf="(groupWhitelisted(['admin', 'operation'])) || (groupWhitelisted(['expert']) && delivery.payAtDelivery && delivery.payAtDeliveryAmount > 0)">
          <h3 class="red-text">Contanti da Incassare</h3>
          <p class="red-text">{{ (delivery?.payAtDeliveryAmount || 0) | currency:'EUR' }}</p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Prova e reso del prodotto</h3>
          <p>{{delivery.tryAndReturn ? "Sì" : "No"}}</p>
        </div>

        <br class="clear">
        <div class="col-100 grid-element field resize-contain-cl">
          <div class="flex_wrap inner-contain-cl"> 
            <h3 style="margin-bottom: 16px;">Prodotto </h3>
            <h3 style="margin-bottom: 16px;">Quantità</h3>
            <h3 style="margin-bottom: 16px;">Variant</h3>
          </div>
          <div style="display: flex; justify-content: flex-start; " class="prodTable relative-inner-cl" *ngFor="let dProduct of delivery.deliveryProducts">
            <div style="width: 222px; cursor: pointer; min-width: auto;" (click)="showImage(dProduct)">{{dProduct.product?.name}} </div>
            <div style="width: 218px; min-width: auto;">{{ dProduct?.quantity }} </div>
            <div style="width: 250px; min-width: auto;" class="pd-re-cl"><b>({{ dProduct?.product?.productOptionTitle }})</b>  {{ dProduct?.productVariant?.variantName || "N/A" }}</div>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="order-management-box" style="margin-top: 15px;">
      <fieldset>
        <legend>RECEIPT INFO:</legend>
        <div class="col-50 grid-element field">
          <h3>Receiver Name</h3>
          <p *ngIf="delivery?.receiverType != null">
            {{ 
              (delivery?.receiverType?.toLowerCase() === 'other' || delivery?.receiverType?.toLowerCase() === 'concierge') 
              ? delivery?.receiverName + ' ' + delivery?.receiverSurname
              : delivery.surname + ' ' + delivery.name 
            }}
          </p>
          <p *ngIf="delivery?.receiverType === null">
            ---
          </p>
        </div>

        <div class="col-50 grid-element field">
          <h3>Receipt</h3>
          <p>
            <a style="cursor: pointer;" *ngIf="delivery?.receipt" target="_blank" href="{{ delivery?.receipt }}" download>
              See Receipt
            </a>
          </p>
          <span *ngIf="!delivery.receipt">---</span>
        </div>
      </fieldset>
    </div>

    <div class="doc-notes-box" style="margin-top: 15px;">
      <fieldset>
        <legend>DOCUMENTAZIONE E NOTE:</legend>
        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <h3>Numero DDT</h3>
          <p>{{delivery.ddtNumber || "N/A"}}</p>
        </div>
        <div class="col-50 grid-element field" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <h3>File DDT</h3>
          <p>
            <a style="cursor: pointer;" *ngIf="delivery.ddtFile" (click)="$event.preventDefault(); showDdt()">
              {{delivery.ddtFile | replace:'-.{4}(\..{3,4})$':'$1'}}
            </a>
            <span *ngIf="!delivery.ddtFile">---</span>
          </p>
        </div>
        <div class="grid-element-full field">
          <h3>Note</h3>
          <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{delivery.notes || "N/A"}}</p>
        </div>
        <div class="grid-element-full field" *ngIf="groupWhitelisted(['admin', 'expert', 'operation'])">
          <h3>Note interne</h3>
          <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{delivery.internalNotes || "N/A"}}</p>
        </div>
      </fieldset>
    </div>

    <div class="logs-box" style="margin-top: 15px;" *ngIf="groupWhitelisted(['admin', 'operation'])">
      <fieldset>
        <legend>LOGS:</legend>
        <div class="col-100 grid-element field">
          <p>{{ "Consegna creata " + (delivery?.createdAt | date: 'dd/MM/yyyy HH:mm:ss') }}</p>
          <p *ngIf="delivery?.deliveryStartedAt">{{ "Consegna Partita " + (delivery?.deliveryStartedAt | date: 'dd/MM/yyyy HH:mm:ss') }}</p>
          <p *ngIf="delivery?.deliveryDeliveredAt">{{ "Consegna Effettuata " + (delivery?.deliveryDeliveredAt | date: 'dd/MM/yyyy HH:mm:ss') }}</p>
        </div>
        <div class="col-100 grid-element field" *ngIf="delivery?.readDelivery">
          <p id="outpuReadDelivery" class="green-text" *ngIf="delivery.deliveryReadByPartner"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;Consegna visualizzata Partner
            {{delivery?.deliveryReadAtByPartner | date: 'dd/MM/yyyy HH:mm:ss'}}
          </p>
          <p id="outpuReadDelivery" class="blue-text" *ngIf="delivery.deliveryReadByExpert"><i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;Consegna Visualizzata Valet
            {{delivery?.deliveryReadAtByExpert | date: 'dd/MM/yyyy HH:mm:ss'}}
          </p>
        </div>
      </fieldset>
    </div>
  </div>
</section>
-->

<section class="header-options">

  <div class="">
    <span class="left">
      <button class="btn btn-white has-margin-right" (click)="print($event)">
        <i class="ml-10 fas fa-file"></i>&nbsp;Stampa
      </button>
    </span>
    <span class="left">
      <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="directions($event)">
        <i class="ml-10 fas fa-directions"></i>&nbsp;Maps
      </button>
    </span>
    <span class="left">
      <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="showLink($event)">
        <i class="ml-10 fas fa-link"></i>&nbsp;Share
      </button>
      <button class="btn btn-white has-margin-right" style="margin-left: 5px;" *ngIf="delivery?.status != deliveryStatus?.delivered" (click)="showLink($event, 'delivered')">
        <i class="ml-10 fas fa-link"></i>&nbsp;Delivered Link
      </button>
      <button class="btn btn-white has-margin-right" style="margin-left: 5px;" (click)="expertModal(delivery)" *ngIf="(groupWhitelisted(['admin', 'operation']) || (groups.includes('expert') && user?.expert?.isTeamLeader))">
        <i class="ml-10 fas fa-user-plus"></i>&nbsp;Assegna
      </button>
    </span>
    <span class="left">
      <button class="btn btn-white has-margin-right" (click)="accepting(delivery.id)" *ngIf="groupWhitelisted('partner') && delivery?.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned) && delivery?.createdFrom === null">
        Accetta<i class="ml-10 fas fa fa-check"></i>
      </button>
    </span>
    <span class="left">
      <button class="btn btn-white has-margin-right" (click)="refusing(delivery.id)" *ngIf="groupWhitelisted('partner') && delivery?.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned) && delivery?.createdFrom === null">
        Rifiuta  <i class="ml-10 fas fa-times-circle"></i>
      </button>
    </span>

    <!--
    <div 
      class="col-48 grid-element" 
      *ngIf="(
        (groupWhitelisted(['admin', 'operation', 'partner'])) 
        && (delivery?.expertIdentityCheck)  
        && (delivery.status === 'assigned' || delivery.status === 'created' || delivery.status === 'accepted' || delivery.status === 'delivering')
      )"
    >
      <label class="toggle-container" for="expertIdentityCheck">
        <input type="checkbox" id="expertIdentityCheck" [(ngModel)]="expertIdentityCheck" (ngModelChange)="onExpertIdentityCheckChange(delivery.id, $event)">
        <span class="toggle-switch"></span>
        Identity Verification
      </label>
    </div>

    <div 
      class="col-48 grid-element" 
      *ngIf="(
        (groupWhitelisted(['admin', 'operation', 'partner'])) 
        && (delivery?.deliveryCodeRequired)
        && (delivery.status === 'assigned' || delivery.status === 'created' || delivery.status === 'accepted' || delivery.status === 'delivering')
      )"
    >
      <label class="toggle-container" for="deliveryCodeRequired">
        <input type="checkbox" id="deliveryCodeRequired" [(ngModel)]="customerVerification" (ngModelChange)="onCustomerVerificationChange(delivery.id, $event)">
        <span class="toggle-switch"></span>
        Customer Verification
      </label>
    </div>
    -->

    <br class="clear">
  </div>

  <div class="delivery-security not-print" *ngIf="(
    (groups.includes('admin') || groups.includes('operation')) && 
    (delivery?.partner?.deliveryCodeCheck || delivery?.status === 'assigned' || delivery?.status === 'delivering')
  )">
    <div class="">
      <label class="toggle-container" for="valetIdentity">
        <input type="checkbox" id="valetIdentity" [checked]="expertIdentityCheck" (click)="onExpertIdentityCheckChange(delivery?.id, $event)">
        <span class="toggle-switch"></span>
        VERIFICA DELL'IDENTITÀ VALET
      </label>
    </div>

    <div class="" *ngIf="(
      (groups.includes('admin') || groups.includes('operation')) && 
      (delivery?.partner?.deliveryCodeCheck || delivery?.status === 'created' || delivery?.status === 'assigned' || delivery?.status === 'delivering')
    )">
      <label class="toggle-container" for="deliveryCheck">
        <input type="checkbox" id="deliveryCheck" [checked]="customerVerification" (click)="onCustomerVerificationChange(delivery?.id, $event)">
        <span class="toggle-switch"></span>
        CODICE DI CONSEGNA RICHIESTO
      </label>
    </div>
  </div>
</section>
<section class="dlx-page" *ngIf="delivery">

  <button class="btn center has-margin-top" (click)="delivering(delivery.id)" *ngIf="selected == 'active' && groupWhitelisted(['expert']) && delivery.status == deliveryStatus.assigned">
    In consegna<i class="ml-10 fas fa-truck"></i>
  </button>

  <div class="dlx-wrapper">
    <div class="top-items">
      <h1 class="dlx-title"><i class="fas fa-truck"></i> Consegna #{{ delivery?.id }}</h1>
      <div class="dlx-item" *ngIf="serviceDetails?.image">
        <div class="dlx-value dlx-status-no">
          <img height="50px" width="50px" src="{{ serviceDetails?.image }}" alt="">
        </div>
      </div>
    </div>
    <div class="dlx-section delivery-details">
      <h2><i class="fas fa-info-circle"></i>DATI DI CONSEGNA E RITIRO:</h2>
      <div class="dlx-grid">
        <div class="dlx-item">
          <div class="dlx-label">Stato</div>
          <div class="dlx-value not-print status {{deliveryStatusAux.css(delivery.status)}}" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
          </div>
          <div class="dlx-value">
            {{ deliveryStatusAux.ln('it', delivery.status)?.toUpperCase() }}
          </div>
        </div>
        
        <div class="dlx-item">
          <div class="dlx-label">Data Consegna</div>
          <div class="dlx-value">
            {{ (delivery.actualDate || delivery.deliveryDate) | date:"dd/MM/yyyy" || "N/A" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="serviceDetails?.pricingModel?.toLowerCase() != 'hourlyrate'">
          <div class="dlx-label">Fascia oraria Consegna</div>
          <div class="dlx-value">
            {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "N/A"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "N/A"}}
          </div>
        </div>

        <div class="dlx-item" *ngIf="serviceDetails?.pricingModel?.toLowerCase() === 'hourlyrate'">
          <div class="dlx-label">Start and End Time</div>
          <div class="dlx-value">
            {{(delivery.startTime) ? (delivery.startTime | time: 'HH:mm') : "N/A"}} - {{(delivery.endTime) ? (delivery.endTime | time: 'HH:mm') : "N/A"}}
          </div>
        </div>

        <div class="dlx-item" *ngIf="serviceDetails === null">
          <div class="dlx-label">Start and End Time</div>
          <div class="dlx-value">
            {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "N/A"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "N/A"}}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'expert', 'partner', 'operation'])">
          <div class="dlx-label">Ora Ritiro</div>
          <div class="dlx-value">
            {{ delivery?.pickUpTime || "N/A" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <div class="dlx-label">Consegna flessibile</div>
          <div class="dlx-value">
            {{ delivery.requestExpert ? "Sì" : "No" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <div class="dlx-label">Valet</div>
          <div class="dlx-value">
            {{ delivery.expert ? delivery.expert.user.surname + " " + delivery.expert.user.name : "N/A" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted('expert')">
          <div class="dlx-label">Indirizzo di ritiro</div>
          <div class="dlx-value">
            {{ delivery?.pickUpAddress || "N/A" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['partner'])">
          <div class="dlx-label">Mezzo</div>
          <div class="dlx-value" *ngIf="!delivery.expert">
            {{ "N/A" }}
          </div>
          <div class="dlx-value" *ngFor="let vehicle of delivery.expert?.vehicles">
            {{ vehicle.name }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['partner'])">
          <div class="dlx-label">Telefono esperto</div>
          <div class="dlx-value">
            {{ delivery.expert?.phone || "N/A" }}
          </div>
        </div>

      </div>
    </div>

    <div class="dlx-section service-details">
      <h2><i class="fas fa-store"></i>SCELTA DEL SERVIZIO :</h2>

      <div class="dlx-grid">
        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'expert', 'operation'])">
          <div class="dlx-label">Partner</div>
          <div class="dlx-value">
            {{ delivery.partner?.businessName || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Nome Servizio</div>
          <div class="dlx-value">
            {{ 
              groupWhitelisted(['partner']) ?
              serviceDetails?.serviceName?.toUpperCase() :
              showServiceDetails(delivery?.service)?.service?.serviceName?.toUpperCase() || "N/A" 
            }} 
          </div>
        </div>
        
        <div class="dlx-item">
          <div class="dlx-label">Tipo Servizio</div>
          <div class="dlx-value">
            {{ delivery?.serviceType &&
              (delivery.serviceType.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
              (delivery.serviceType.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
              (delivery.serviceType.toLowerCase() === "sales" ? "Servizi Vendita" : ""))) 
            }} 
          </div>
        </div>
  
        <div class="dlx-item" *ngIf="(serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['admin', 'expert', 'partner']))">
          <div class="dlx-label">Prezzo</div>
          <div class="dlx-value">
            {{ delivery?.productValue | currency:'EUR' }}
          </div>
        </div>
  
        <div class="dlx-item" 
          *ngIf="(
              (serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['partner']))
                || ((serviceDetails?.pricingModel?.toLowerCase() === 'hourlyrate' || serviceDetails?.pricingModel?.toLowerCase() === 'fixedprice') && groupWhitelisted(['partner']) && loggedInPartner?.billingAccess)
          )">
          <div class="dlx-label">Valore Fee</div>
          <div class="dlx-value">
            {{ delivery?.price | currency:'EUR' }}
          </div>
        </div>
  
        <div class="dlx-item" *ngIf="groupWhitelisted(['admin']) || (serviceDetails?.pricingModel?.toLowerCase() === 'sales' && groupWhitelisted(['partner', 'expert']))">
          <div class="dlx-label">Plus / Minus al Prezzo</div>
          <div class="dlx-value">
            {{ delivery?.additionalPrice | currency:'EUR' }}
          </div>
        </div>
      </div>
    </div>

    <div class="dlx-section user-details" *ngIf="showCustomerInformation">
      <h2><i class="fas fa-user"></i>INFORMAZIONI DESTINATARIO E MITTENTE:</h2>

      <div class="dlx-grid">
        <div class="dlx-item">
          <div class="dlx-label">Cognome destinatario</div>
          <div class="dlx-value">
            {{ delivery.surname || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Nome destinatario</div>
          <div class="dlx-value">
            {{ delivery.name || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Sms Telefonici</div>
          <div class="dlx-value">
            {{ delivery?.smsPhoneNo || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Indirizzo</div>
          <div class="dlx-value">
            {{ ((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Citofono</div>
          <div class="dlx-value">
            {{ delivery.intercom || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Telefono destinatario</div>
          <div class="dlx-value">
            {{ delivery.receiverPhone || "N/A" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Email destinatario</div>
          <div class="dlx-value">
            {{ delivery.email || "N/A" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Cognome mittente</div>
          <div class="dlx-value" *ngIf="delivery.customer">
            {{ delivery.customer.user.surname || "N/A" }}
          </div>
          <div class="dlx-value" *ngIf="!delivery.customer">
            {{ delivery.senderSurname || "N/A" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Nome mittente</div>
          <div class="dlx-value" *ngIf="delivery.customer">
            {{ delivery.customer.user.name || "N/A" }}
          </div>
          <div class="dlx-value" *ngIf="!delivery.customer">
            {{ delivery.senderName || "N/A" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Telefono mittente</div>
          <div class="dlx-value" *ngIf="delivery.customer">
            {{ delivery.customer.phone || "N/A" }}
          </div>
          <div class="dlx-value" *ngIf="!delivery.customer">
            {{ delivery.senderPhone || "N/A" }}
          </div>
        </div>
      </div>

    </div>

    <div class="dlx-section product-details">
      <h2><i class="fa fa-folder-open"></i>GESTIONE DELL’ORDINE:</h2>

      <div class="dlx-grid">
        <div class="dlx-item">
          <div class="dlx-label">Pagamento alla consegna</div>
          <div class="dlx-value">
            {{ delivery.payAtDelivery ? "Sì" : "No" }}
          </div>
        </div>
  
        <div class="dlx-item" *ngIf="(groupWhitelisted(['admin', 'operation'])) || (groupWhitelisted(['expert']) && delivery.payAtDelivery && delivery.payAtDeliveryAmount > 0)">
          <div class="dlx-label">Contanti da Incassare</div>
          <div class="dlx-value highlight-red">
            {{ (delivery?.payAtDeliveryAmount || 0) | currency:'EUR' }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Prova e reso del prodotto</div>
          <div class="dlx-value">
            {{ delivery.tryAndReturn ? "Sì" : "No" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label"></div>
          <div class="dlx-value">
            
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Prodotto</div>
          <div class="dlx-value" (click)="showImage(dProduct)" *ngFor="let dProduct of delivery.deliveryProducts">
            {{ dProduct.product?.name }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Prodotto Immagine</div>
          <div class="dlx-value flowers-value">
            <img *ngFor="let dProduct of delivery.deliveryProducts"
                [src]="dProduct?.product?.image || './assets/img/no-image.jpg'"
                alt="Product Image"
                height="60px" 
                width="60px">
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Quantità</div>
          <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
            {{ dProduct?.quantity }}
          </div>
        </div>
  
        <div class="dlx-item">
          <div class="dlx-label">Variant</div>
          <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
            <span *ngIf="dProduct?.product?.productOptionTitle">
              <b>({{ dProduct?.product?.productOptionTitle }})</b>
            </span> 
            {{ dProduct?.productVariant?.variantName || "N/A" }}
          </div>
        </div>

      </div>
    </div>

    <div class="dlx-section receipt-details">
      <h2><i class="fas fa-receipt"></i>RECEIPT INFO:</h2>
      <div class="dlx-grid">
        <div class="dlx-item">
          <div class="dlx-label" style="cursor: pointer;" (click)="showSignature(delivery)">Receiver Name</div>
          <div class="dlx-value" *ngIf="delivery?.receiverType != null">
            {{ 
              (delivery?.receiverType?.toLowerCase() === 'other' || delivery?.receiverType?.toLowerCase() === 'concierge') 
              ? delivery?.receiverName + ' ' + delivery?.receiverSurname
              : delivery.surname + ' ' + delivery.name 
            }}
          </div>
          <div class="dlx-value" *ngIf="delivery?.receiverType === null"> {{ "N/A" }} </div>
        </div>
  
        <div class="dlx-item not-print">
          <div class="dlx-label">Receipt</div>
          <div class="dlx-value">
            <a style="cursor: pointer;" *ngIf="delivery?.receipt" target="_blank" href="{{ delivery?.receipt }}" download>
              See Receipt
            </a>
          </div>
          <div class="dlx-value" *ngIf="!delivery?.receipt">{{ "N/A" }}</div>
        </div>
      </div>
    </div>

    <div class="dlx-section doc-details">
      <h2><i class="fa fa-book"></i>DOCUMENTAZIONE E NOTE:</h2>
      <div class="dlx-grid">
        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'partner', 'operation'])">
          <div class="dlx-label">Numero DDT</div>
          <div class="dlx-value">
            {{ delivery.ddtNumber || "N/A" }}
          </div>
        </div>
  
        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'partner', 'operation', 'expert'])">
          <div class="dlx-label not-print">File DDT</div>
          <div class="dlx-value not-print">
            <a style="cursor: pointer;" *ngIf="delivery.ddtFile" (click)="$event.preventDefault(); showDdt(delivery)">
              {{delivery.ddtFile | replace:'-.{4}(\..{3,4})$':'$1'}}
            </a>
          </div>
          <div class="dlx-value" class="not-print" *ngIf="!delivery.ddtFile">{{ "N/A" }}</div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">Note</div>
          <div class="dlx-value">
            {{ delivery.notes || "N/A" }}
          </div>
        </div>

        <div class="dlx-item">
          <div class="dlx-label">PERSONALIZZAZIONE</div>
          <div class="dlx-value">
            {{ delivery?.personalizeSaleNotes || "N/A" }}
          </div>
        </div>

        <div class="dlx-item" *ngIf="groupWhitelisted(['admin', 'expert', 'operation'])">
          <div class="dlx-label">Note interne</div>
          <div class="dlx-value">
            {{
              showNoteInternAndProductManagement(delivery)
            }}
          </div>
        </div>
      </div>
    </div>

    <!--
    <div class="dlx-footer not-print" *ngIf="groupWhitelisted(['admin', 'operation'])">
      
      <div>
        <p class="delivery-create">
          {{ "Consegna creata " + (delivery?.createdAt | date: 'dd/MM/yyyy HH:mm:ss') }} 
          <b *ngIf="createdByUserName" class="text-uppercase">[ {{ createdByUserName }} ]</b>
        </p>
        <p class="delivery-delivering" *ngIf="delivery?.deliveryStartedAt">
          {{ "Consegna Partita " + (delivery?.deliveryStartedAt | date: 'dd/MM/yyyy HH:mm:ss') }} 
          <b class="text-uppercase">[ {{ delivery?.expert ? delivery.expert.user.surname + ' ' + delivery.expert.user.name : "N/A" }} ]</b>
        </p>
        <p class="delivery-delivered" *ngIf="delivery?.deliveryDeliveredAt">
          {{ "Consegna Effettuata " + (delivery?.deliveryDeliveredAt | date: 'dd/MM/yyyy HH:mm:ss') }} 
          <b class="text-uppercase">[ {{ delivery?.expert ? delivery.expert.user.surname + ' ' + delivery.expert.user.name : "N/A" }} ]</b>
        </p>
      </div>

      <div *ngIf="delivery?.readDelivery">
        <p *ngIf="delivery.deliveryReadByPartner" class="green-text">
          <i class="fa fa-check" aria-hidden="true"></i> &nbsp;
          Consegna visualizzata Partner: 
          {{ delivery?.deliveryReadAtByPartner | date: 'dd/MM/yyyy HH:mm:ss' }}
          <b class="text-uppercase">[ {{ deliveryReadByPartner }} ]</b>
        </p>
        <p *ngIf="delivery.deliveryReadByExpert" class="blue-text">
          <i class="fa fa-chevron-down" aria-hidden="true"></i> &nbsp;
          Consegna Visualizzata Valet: 
          {{ delivery?.deliveryReadAtByExpert | date: 'dd/MM/yyyy HH:mm:ss' }}
          <b class="text-uppercase">[ {{ deliveryReadByExpert }} ]</b>
        </p>
      </div>
      
      <div class="delivery-updates-accordion" *ngIf="delivery?.deliveryUpdates?.length">
        <button
          type="button"
          class="delivery-updates-header"
          (click)="toggleDeliveryUpdates()"
        >
          <span>
            <i class="fa fa-history" aria-hidden="true"></i>
            Storico modifiche consegna
            <small>({{ delivery.deliveryUpdates.length }})</small>
          </span>

          <i
            class="fa"
            [ngClass]="showDeliveryUpdates ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-hidden="true"
          ></i>
        </button>

        <div class="delivery-updates-body" *ngIf="showDeliveryUpdates">
          <div
            class="delivery-update-row"
            *ngFor="let update of delivery.deliveryUpdates; let i = index"
          >
            <div class="delivery-update-index">
              #{{ i + 1 }}
            </div>

            <div class="delivery-update-content">
              <p class="delivery-update-title">
                Consegna modificata
              </p>

              <p class="delivery-update-meta">
                {{ update?.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}

                <b class="text-uppercase">
                  [ {{ getDeliveryUpdateUserName(update) }} ]
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="delivery-updates-empty" *ngIf="delivery && !delivery?.deliveryUpdates?.length">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Nessuna modifica registrata per questa consegna.
      </div>
    </div>
    -->

    <div class="dlx-footer not-print" *ngIf="groupWhitelisted(['admin', 'operation'])">
      <div class="delivery-log-panel" [class.is-open]="showDeliveryTimeline">
        <button
          type="button"
          class="delivery-log-toggle"
          (click)="toggleDeliveryTimeline()"
        >
          <div class="delivery-log-summary">
            <div class="delivery-log-symbol">
              <i class="fa fa-list-ul" aria-hidden="true"></i>
            </div>

            <div class="delivery-log-heading">
              <h4>Storico consegna</h4>
              <p>
                <span>{{ deliveryTimeline?.length || 0 }} attività</span>
                <span *ngIf="deliveryTimeline?.length">
                  Ultimo aggiornamento:
                  {{ deliveryTimeline[deliveryTimeline.length - 1]?.date | date: 'dd/MM/yyyy HH:mm' }}
                </span>
              </p>
            </div>
          </div>

          <div class="delivery-log-action">
            <span class="delivery-log-badge" *ngIf="deliveryTimeline?.length">
              {{ showDeliveryTimeline ? 'Nascondi' : 'Mostra' }}
            </span>

            <i
              class="fa"
              [ngClass]="showDeliveryTimeline ? 'fa-angle-up' : 'fa-angle-down'"
              aria-hidden="true"
            ></i>
          </div>
        </button>

        <div class="delivery-log-body" *ngIf="showDeliveryTimeline">
          <div class="delivery-log-list" *ngIf="deliveryTimeline?.length; else noTimeline">
            <div
              class="delivery-log-item"
              *ngFor="let item of deliveryTimeline; let i = index"
              [ngClass]="item.className"
              [style.--i]="i"
            >
              <div class="delivery-log-time">
                <strong>{{ item.date | date: 'HH:mm' }}</strong>
                <span>{{ item.date | date: 'dd/MM/yyyy' }}</span>
              </div>

              <div class="delivery-log-line">
                <span></span>
              </div>

              <div class="delivery-log-card">
                <div class="delivery-log-card-top">
                  <div class="delivery-log-title">
                    <span class="delivery-log-index">#{{ i + 1 }}</span>

                    <span class="delivery-log-icon">
                      <i class="fa" [ngClass]="item.icon" aria-hidden="true"></i>
                    </span>

                    <strong>{{ item.label }}</strong>
                  </div>

                  <span class="delivery-log-full-date">
                    {{ item.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </span>
                </div>

                <div class="delivery-log-user" *ngIf="item.user">
                  <i class="fa fa-user-circle" aria-hidden="true"></i>
                  <b class="text-uppercase">[ {{ item.user }} ]</b>
                </div>
              </div>
            </div>
          </div>

          <ng-template #noTimeline>
            <div class="delivery-log-empty" *ngIf="delivery">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              Nessuna attività registrata per questa consegna.
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</section>



